import { useState } from "react";

const { PaymentElement, useElements, useStripe } = require("@stripe/react-stripe-js");

function StripePaymentForm({ order, onPaid }) {
  const elements = useElements();
  const stripe = useStripe();
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");

    if (!stripe || !elements) {
      return;
    }

    setSubmitting(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/order/${order.order_number}/confirmation?email=${encodeURIComponent(
          order.customer_email,
        )}`,
      },
      redirect: "if_required",
    });

    if (result.error) {
      setError(result.error.message || "Card payment failed. Please try again.");
      setSubmitting(false);
      return;
    }

    onPaid?.();
    setSubmitting(false);
  }

  return (
    <form className="stripe-payment-form" onSubmit={handleSubmit}>
      <PaymentElement />
      {error ? <div className="cart-alert cart-alert--error">{error}</div> : null}
      <button className="btn btn-primary btn-block" disabled={!stripe || submitting} type="submit">
        {submitting ? "Processing" : "Pay Now"}
      </button>
    </form>
  );
}

export default StripePaymentForm;
